import {OnInit, Component, Input, HostListener, ElementRef} from '@angular/core';
import {ActivityDictionary} from '../../../directory-item/activity/activity.dictionary';

declare const $: any;

@Component({
    selector: 'permissions',
    templateUrl: './permissions.component.html',
    styleUrls: ['./permissions.component.scss']
})
export class PermissionsComponent implements OnInit {
    @Input() permissions;
    @Input() showPeriod = true;
    @Input() parentElementSelector: string;

    public isShow: boolean = false;
    public isDirectionTop: boolean = false;

    private parentRect;
    private element;

    constructor(private _eref: ElementRef) {}

    ngOnInit() {
        if (this.parentElementSelector) {
            this.parentRect = document.querySelector(this.parentElementSelector).getBoundingClientRect();
            this.element = this._eref.nativeElement;
        }
    }

    public toggle(): void {
        if (this.parentRect) {
            this.isDirectionTop = this.isOverflowBottom();
        } else {
            this.isDirectionTop = false;
        }

        this.isShow = !this.isShow;
    }

    @HostListener('document:click', ['$event.target'])
    private hide(targetElement: HTMLElement): void {
        if (!this._eref.nativeElement.contains(targetElement)) {
            this.isShow = false;
        }
    }

    private isOverflowBottom(): boolean {
        if (this.parentRect) {
            const maxHeight = this.parentRect.bottom;

            const elementReact = this.element.getBoundingClientRect();
            const dropDownHeight = this.element.querySelector('.permissions__drop-down').getBoundingClientRect().height;
            const elementBottomPosition = elementReact.bottom + dropDownHeight;

            return elementBottomPosition > maxHeight;
        }

        return false;
    }

    getPermission(permission): string {
        return ActivityDictionary.getValue(permission);
    }

}



// WEBPACK FOOTER //
// /app/src/app/views/documents/document-item/permissions/permissions.component.ts